import type { IntlShape } from 'react-intl';
import logError from '@alltrails/core/utils/logError';
import TrailRouteType from '../types/TrailRouteType';

export default function getTrailRouteTypeLabel(intl: IntlShape, routeType: TrailRouteType): string {
  switch (routeType) {
    case 'L':
      return intl.formatMessage({ defaultMessage: 'Loop' });
    case 'O':
      return intl.formatMessage({ defaultMessage: 'Out & back' });
    case 'P':
      return intl.formatMessage({ defaultMessage: 'Point to point' });
    default:
      logError(new Error(`Unknown route type: ${routeType}`));
      return '';
  }
}
